<template>
  <footer class="footer" style="margin-top:20px; line-height: 10px;">
    <div
      class="copyright text-center"
      style="font-size: .70rem; margin-left:20px; padding: 3px 0px 0px 0px;"
    >
      v{{ version }}
    </div>

    <a style="margin-left:20px;" href="http://www.globechek.com">
      <img src="@/assets/img/domain_outline1.png" >
      <span style="font-size: .85rem; margin-left:5px;">Company</span>
    </a>

    <a style="margin-left:20px;" href="https://www.facebook.com/GlobeChek/">
      <img src="@/assets/img/people_outline1.png" >
      <span style="font-size: .90rem; margin-left:5px;">Social</span>
    </a>

    <div
      class="copyright text-center"
      style="font-size: .85rem; float:right; margin-right:30px; padding: 3px 0px 0px 0px;"
    >
      &copy; {{ new Date().getFullYear() }}
      <a href="https://www.globechek.com" target="_blank" rel="noopener">
        <span>Globe</span><span style="font-weight:bold;">Chek</span>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
};
</script>
<style lang="scss" scoped></style>
